import { Loader2 } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

interface LoadingProps {
	name?: string;
	className?: string;
	message?: string;
}

export function Loading({ name, className, message }: LoadingProps) {
	return (
		<div className={twMerge('flex items-center justify-center', className)} id={name}>
			<div className="flex flex-col items-center gap-4">
				<Loader2 className="size-6 animate-spin text-primary-600" />
				<div className="text-center">
					<p className="text-sm text-gray-600">{message || 'Loading...'}</p>
				</div>
			</div>
		</div>
	);
}
